import { useState } from "react";

import { makeStyles } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";

import { Question } from "types/Survey";
import useEffectOnMount from "hooks/useEffectOnMount";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing(2),
    width: "100%"
  },
  legend: {
    marginBottom: theme.spacing(2)
  }
}));

type Props = {
  question: Question;
  onChangeQuestionValue: (
    questionId: string,
    value: string,
    valid: boolean
  ) => void;
};

export default function QuestionText({
  question,
  onChangeQuestionValue
}: Props) {
  const classes = useStyles();

  const [value, setValue] = useState((question.default as string) || "");
  const [valid, setValid] = useState(question.required ? (question.default ? true : false) : true);
  const [validationTriggered, setValidationTriggered] = useState(false);

  useEffectOnMount(() => {
    onChangeQuestionValue(question.id, value, valid);
  });

  const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const changedValue = event.target.value;
    setValue(changedValue);
    onChangeQuestionValue(question.id, changedValue, validate(changedValue));
    setValidationTriggered(true);
  };

  const validate = (changedValue: string) => {
    if (question.required && (changedValue === null || changedValue === "")) {
      setValid(false);
      return false;
    } else {
      setValid(true);
      return true;
    }
  };

  const error = !valid && validationTriggered;

  return (
    <div className={classes.root}>
      <FormControl
        required={question.required}
        error={error}
        component="fieldset"
        className={classes.formControl}
      >
        <FormLabel component="legend" className={classes.legend}>
          {question.name}
        </FormLabel>
        <FormGroup>
          <TextField
            fullWidth
            label={question.label}
            variant="outlined"
            value={value}
            onChange={handleChangeValue}
          />
        </FormGroup>
        <FormHelperText>
          <span dangerouslySetInnerHTML={{ __html: question.description }} />
        </FormHelperText>
      </FormControl>
    </div>
  );
}
